module.exports = __webpack_public_path__ + "static/question-mark-circle.1472c48521147a178979f5558df05f49.svg";